import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from '../_services/auth.service';
import { UserSessionDataForm } from '../_models/login/user-session-data-form';

@Component({
  selector: 'app-success-dialog-quiz',
  templateUrl: './success-dialog-quiz.component.html',
  styleUrls: ['./success-dialog-quiz.component.css']
})
export class SuccessDialogQuizComponent implements OnInit {

  learningQuizTitle: string;
  routerLink: string;
  testScore: number;
  userDataSession;
  userDisplayName = '';
  urlLink = '';
  msg: string;

  constructor(
    public dialogRef: MatDialogRef<SuccessDialogQuizComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
  ) {
    this.learningQuizTitle = data.title;
    this.routerLink = data.routerLink;
    this.testScore = data.testScore;
  }


  ngOnInit() {

    this.authService.checkUserSession();
    const currentUser = localStorage.getItem('currentUser');
    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
    this.userDataSession = currentUserJson;
    if (currentUserJson != null) {
      if (this.userDataSession.firstName) {
        this.userDisplayName = this.userDataSession.firstName;
      }
    }
    this.testScoreMsg();
  }

  testScoreMsg() {
    //  For Test Score Message
    if (this.testScore > 3) {
      this.msg = "Excellent";
    }
    else if (this.testScore < 2) {
      this.msg = "Need to Improve";
    }

    else {
      this.msg = "Good"
    }
  }

}


